
import firebase from 'firebase/compat/app'
import 'firebase/compat/storage'
import Mixins from '@/shared'
export default {
  name: 'Clubs',
  mixins: [Mixins],
  data () {
    return {
      search: '',
      headers: [
        {
          sortable: false,
          value: 'logo',
          align: 'start  hidden-sm-and-down d-sm-none-table-row'
        },
        {
          text: this.$t('name'),
          sortable: true,
          value: 'name'
        },
        {
          text: this.$t('club-short-name'),
          sortable: true,
          value: 'shortName'
        },
        {
          text: this.$t('city'),
          sortable: true,
          value: 'city'
        },
        {
          text: this.$t('published'),
          sortable: true,
          value: 'published'
        }
      ],
      invalid: true,
      dialog: false,
      createData: {
        name: '',
        nameRules: [
          (v: any) => !!v || this.$t('name-rule')
        ],
        shortName: '' as string,
        shortNameRules: [
          (v: any) => !!v || this.$t('short-name-rule')
        ],
        city: '',
        cityRules: [
          (v: any) => !!v || this.$t('city-rule')
        ]
      },
      clubData: {},
      file: ''
    }
  },
  mounted () {
    this.$store.dispatch('ClubsModule/fetchAndAdd')
  },
  methods: {
    validate () {
      const form: any = this.$refs.clubForm
      if (form.validate() === true) {
        this.invalid = false
        return
      }
      this.invalid = true
    },
    handleFileUpload (file: File) {
      this.file = file
    },
    save () {
      const form: any = this.$refs.clubForm
      if (form.validate()) {
        (this.$store.dispatch as any)('ClubsModule/set', { city: this.createData.city, name: this.createData.name, shortName: this.createData.shortName }).then(async (data: any) => {
          const storageRef = firebase.storage().ref('/clubs/' + data + '.png').put(this.file)
          storageRef.on('state_changed', snapshot => {
            this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          }, error => {
            console.log(error)
          }, () => {
            this.uploadValue = 100
            storageRef.snapshot.ref.getDownloadURL().then((url) => {
              (this.$store.dispatch as any)('ClubsModule/set', {
                id: data,
                logo: url
              })
              Object.keys(this.clubData).forEach((key) => {
                this.clubData[key] = ''
              })
            })
          })
        })
      }
    }
  }
}
